export default "__VITE_ASSET__ECKEiA8d__"